Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = componentWithNamesOfHOCs;

var _airbnbPropTypes = require('airbnb-prop-types');

var _getComponentName = require('airbnb-prop-types/build/helpers/getComponentName');

var _getComponentName2 = _interopRequireDefault(_getComponentName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function componentWithNamesOfHOCs(Component) {
  var displayName = (0, _getComponentName2['default'])(Component);

  for (var _len = arguments.length, namesOfHOCs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    namesOfHOCs[_key - 1] = arguments[_key];
  }

  return (0, _airbnbPropTypes.or)([(0, _airbnbPropTypes.childrenOfType)(Component), (0, _airbnbPropTypes.componentWithName)(displayName)].concat(_toConsumableArray(namesOfHOCs.map(function (name) {
    return (0, _airbnbPropTypes.componentWithName)(String(name) + '(' + String(displayName) + ')');
  }))), 'componentWithNamesOfHOCs: ' + String([displayName].concat(namesOfHOCs).join(', ')));
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/propTypes/componentWithNamesOfHOCs.js
// module id = 92
// module chunks = 168707334958949